// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__E71u9","label":"Category_label__3hRaG","content":"Category_content__318Eo","header":"Category_header__3mPFu","location":"Category_location__209Sy"};